import { FC, PropsWithChildren, ReactNode } from 'react';
import { classNames } from 'primereact/utils';

interface DashboardSectionProps {
  title: string;
  description?: string;
  /** Optional right-aligned header slot (e.g. a refresh button). */
  action?: ReactNode;
  /** Extra classes on the card — e.g. `h-full` so grid siblings match height. */
  className?: string;
}

/**
 * A white rounded card that frames one dashboard section. Uses the same
 * hairline border (`fletchers-gray-110`) and green-tinted heading rhythm as
 * the rest of the app so all four sections read as one system.
 */
export const DashboardSection: FC<PropsWithChildren<DashboardSectionProps>> = ({
  title,
  description,
  action,
  className,
  children,
}) => (
  <section
    className={classNames(
      'border-fletchers-gray-110 flex flex-col gap-4 rounded-lg border bg-white p-6 shadow-sm',
      className,
    )}
  >
    <div className="flex items-start justify-between gap-4">
      <div className="flex flex-col gap-1">
        <h2 className="text-fletchers-black-900 text-[18px]/[24px] font-semibold">{title}</h2>
        {description && <p className="text-fletchers-gray-200 text-sm">{description}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
    {children}
  </section>
);
